import { createFileRoute } from '@tanstack/react-router';
import { SellEndpointDetail } from '../../pages/sell/SellEndpointDetail';

export const Route = createFileRoute('/dashboard/sell/endpoints/$endpointId')({
  component: SellEndpointDetailRoute,
});

function SellEndpointDetailRoute() {
  const { endpointId } = Route.useParams();
  return <SellEndpointDetail endpointId={endpointId} />;
}
